export default __webpack_public_path__ + "media/images/btn_download-faded-0e377fe9.svg";